import _ from 'underscore';
import { getStorage } from '../../home24/helpers/storage-factory';

/**
 * Method iterates over cookieCallbacks object and executes callback methods when cookiename is set
 */
export function executeCookieCallbacks() {
  _.each(
    this.cookieCallbacks,
    function(callbackName, key) {
      var cookieData = getStorage().get(key);
      var callback = this[callbackName];

      if (cookieData && _.isFunction(callback)) {
        callback.call(this, cookieData);
        getStorage().unset(key);
      }
    },
    this
  );
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/core/base-tracking.js
 **/